/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedWheelchairIcon20Solid = forwardRef('MedWheelchairIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.655 4.815a2.5 2.5 0 1 0-2.496.187l.729 5.855a1.875 1.875 0 0 0 1.86 1.643h4.35l2.042 4.06a1.25 1.25 0 0 0 1.676.556l1.791-.895a1.25 1.25 0 0 0-1.118-2.236l-.676.338-1.655-3.29A1.875 1.875 0 0 0 13.483 10H9.3l-.186-1.5H12.6a1.25 1.25 0 1 0 0-2.5H8.802l-.147-1.185Z" }),
        React.createElement("path", { d: "M5.068 9.396a1.25 1.25 0 1 0-1.742-1.792 6.55 6.55 0 1 0 9.572 8.92 1.25 1.25 0 1 0-1.911-1.613 4.05 4.05 0 1 1-5.919-5.514Z" })));
});
